const csrfHeaderName = 'CSRF-Token';
const csrfCookieName = 'CSRF-Token';

// Axios 1.x no longer sends XSRF headers cross-origin just because credentials
// are enabled. Allow the configured API origin, not arbitrary destinations.
export const isTrustedXsrfRequest = config => {
    try {
        const apiOrigin = new URL(
            process.env.REACT_APP_MICROSERVICES_BASE_URL || window.location.origin,
            window.location.href
        ).origin;
        const requestOrigin = new URL(
            config.url,
            config.baseURL || window.location.href
        ).origin;
        return requestOrigin === apiOrigin;
    } catch {
        return false;
    }
};

/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default config => {
    const configUpdate = config;
    configUpdate.withCredentials = true;
    configUpdate.xsrfCookieName = csrfCookieName;
    configUpdate.xsrfHeaderName = csrfHeaderName;
    configUpdate.withXSRFToken = isTrustedXsrfRequest;
    return configUpdate;
};